import fetch from 'cross-fetch';
import {
	ChangeEmailRequest,
	ChangeEmailResponse,
	ChangeEmailError,
	EmailChangeAction,
} from './change-email';
import { sameOriginRequestPolicy } from '../actions';
import { RequiredBodyError } from '../error';
import { HTTP_STATUS_NO_CONTENT, HTTP_STATUS_BAD_REQUEST, HTTP_STATUS_INTERNAL_SERVER_ERROR } from '../../../helpers/validation/common';

export class RemoteEmailChangeAction {
	private readonly baseUrl: string | null;

	constructor(baseUrl: string | null) {
		this.baseUrl = baseUrl;
	}

	action: EmailChangeAction = async (
		request?: ChangeEmailRequest
	): Promise<ChangeEmailResponse> => {
		const base: string = this.baseUrl || '';
		if (!request) {
			throw new RequiredBodyError();
		}

		const response: Response = await fetch(
			`${base}/api/login-hub/change-email`,
			{
				...sameOriginRequestPolicy,
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
				},
				body: JSON.stringify(request),
				mode: 'cors',
			}
		);

		if (response.status === HTTP_STATUS_NO_CONTENT) {
			return {
				status: HTTP_STATUS_NO_CONTENT,
			};
		}

		if (response.status === HTTP_STATUS_BAD_REQUEST || response.status === HTTP_STATUS_INTERNAL_SERVER_ERROR) {
			try {
				const jsonResponse = await response.json();
				const errorType = jsonResponse?.error as ChangeEmailError | undefined;
				return {
					status: response.status as typeof HTTP_STATUS_BAD_REQUEST | typeof HTTP_STATUS_INTERNAL_SERVER_ERROR,
					error: errorType,
				};
			} catch (jsonError) {
				return {
					status: response.status as typeof HTTP_STATUS_BAD_REQUEST | typeof HTTP_STATUS_INTERNAL_SERVER_ERROR,
				};
			}
		}

		return {
			status: response.status as typeof HTTP_STATUS_BAD_REQUEST | typeof HTTP_STATUS_INTERNAL_SERVER_ERROR,
		};
	};
}
